import { useState } from 'react';

export interface LoadingInfo {
  isLoading: boolean;
  loadingDetails: string[];
}

export interface LoadingStatusProvider {
  endLoading: () => void;
  startLoading: (message: string) => void;
  addLoadingDetail: (message: string) => void;
  removeLoadingDetail: (message: string) => void;
}

export const useLoadingInfo: (info?: LoadingInfo) => { loadingInfo: LoadingInfo; loadingProvider: LoadingStatusProvider } = (info) => {
  const [loadingInfo, setLoadingInfo] = useState<LoadingInfo>(info ?? { isLoading: true, loadingDetails: ['Initializing...'] });
  const statusList: string[] = [];

  const endLoading: () => void = () => {
    statusList.length = 0;
    setLoadingInfo({ isLoading: false, loadingDetails: [...statusList] });
  };

  const startLoading: (message: string) => void = (message) => {
    statusList.push(message);
    setLoadingInfo({ isLoading: true, loadingDetails: [...statusList] });
  };

  const addLoadingDetail: (message: string) => void = (message) => {
    if (loadingInfo.isLoading === true) {
      statusList.push(message);
      setLoadingInfo({ ...loadingInfo, loadingDetails: [...statusList] });
    }
  };

  // This function likely performs badly.  It should not be required too often, however.
  const removeLoadingDetail: (message: string) => void = (message) => {
    if (loadingInfo.isLoading === true) {
      const stati: string[] = statusList.filter((m) => {
        return m !== message;
      });
      statusList.length = 0;
      statusList.push(...stati);
      setLoadingInfo({ ...loadingInfo, loadingDetails: [...statusList] });
    }
  };

  return {
    loadingInfo,
    loadingProvider: {
      startLoading,
      endLoading,
      addLoadingDetail,
      removeLoadingDetail,
    },
  };
};
